<!-- <ng-contianer *ngIf="!loading">
    <app-header></app-header>
    <div class="wrapper">
        <div class="main"> -->
            <router-outlet></router-outlet>
        <!-- </div>
        <app-footer></app-footer>
    </div>
</ng-contianer> -->